import React, {useCallback} from 'react';
import {FormFieldOption} from '@src/@types/components/Form';
import ErrorRepresentation from '@src/components/ErrorRepresentation/ErrorRepresentation';
import Translate from '@src/components/Translate/Translate';
import useUniqueId from '@src/hooks/useUniqueId';
import useConfigValue from '@src/hooks/useConfigValue';
import config from '@src/helpers/config';
import {ConfigKeys} from '@src/@types/services/Config/ConfigKeys';
import Switch from '@src/components/Fields/Switch';
import classnames from '@src/helpers/classnames';

export default function OrderProductsListenOnlyMyDepartmentsSoundSetting(props: {
    options?: FormFieldOption[],
    error?: Error | null,
    isLoading: boolean,
    className?: string,
}) {
    const id = useUniqueId();
    const label = `SoundsSettings.notifications.new-order-product.play-when-its-has-one-of-my-departments`;
    const name: ConfigKeys = `settings.notifications.new-order-product.only-my-departments`;
    const value = useConfigValue<boolean>(name, true);
    const onChange = useCallback((e: React.FormEvent<HTMLInputElement>) => {
        config().set(name, e.currentTarget.checked);
    }, [name]);

    if (props.error) {
        return <ErrorRepresentation
                error={props.error}
                outsideContainer
                className="mb-0"
        />;
    }

    return <div className={classnames('d-flex', props.className)}>
        <Translate<HTMLLabelElement>
                message={label}
                tag="label"
                htmlFor={id}
                className="form-check-label me-2 mb-0"
        />

        <Switch
                id={id}
                label={undefined}
                onChange={onChange}
                checked={value}
        />
    </div>;
}
